<!-- <router-outlet></router-outlet> -->
<!-- <app-preloader *ngIf="IsLoadingResults"></app-preloader> -->
<app-pre-loader *ngIf="IsLoadingResults"></app-pre-loader>

<div class="container">
  <p-panel header="Assign Template Access">
    <form [formGroup]="AppAccessForm">
      <mat-toolbar class="toolbar">
        <button mat-stroked-button class="btn-primary1" type="button" (click)="onSubmit()">Save</button>
        &nbsp;
        <button mat-stroked-button class="btn-primary1" (click)="onExit()" type="button">Exit</button>
      </mat-toolbar>
      <div class="cardSearch">
        <div class="card-header form-control" data-bs-toggle="collapse" href="#collapseExample" role="button"
          aria-expanded="false" aria-controls="collapseExample">
          <b> Assign App Roles </b><span style="margin-left: 900px;"></span>
        </div>
        <div class="collapse" id="collapseExample">
          <div class="card-body">
            <table cellspacing="0">
              <tr>
                <td>
                  <label>Employee: </label> <br>
                  <p-autoComplete [suggestions]="EmpDetails"
                                  [forceSelection]="true"
                                  formControlName="EmpName" 
                                  placeholder="Enter few Characters for suggestions..." 
                                  (completeMethod)="filterEmp($event)" 
                                  (onSelect)="getEmpNames($event)"
                                  field="EmpName"
                                  (onClear)="ResetEmpDetails()"
                                  [showClear]="true" [minLength]="3" [maxLength]="50" 
                                  showTransitionOptions="0.5s cubic-bezier(0, 0, 0.2, 1)"
                                  [showEmptyMessage]="true">
                </p-autoComplete>
                
                </td>
                <td>
                  <label>Roles: </label> 
                    
                  <p-dropdown [options]="rolesList"
                  [showClear]="true"
                  (onChange)="onRoleChange($event)"
                  placeholder="Select Role Name"
                  optionValue="label"
                  formControlName="Role"
                  ></p-dropdown>
                </td>
                </tr>
                <tr>
                    <td>
                        <div class="row">
                            <div class="mb-3 col-md-6">
                                        <label>SSL<span class="required">*</span></label>
                                        <input  class="form-control col-md-8"
                                        formControlName="SSL" readonly [disabled]="true">
                            </div>
        
                        </div>
                    </td>
                    <td>
                        <div class="row">
                            <div class="mb-3 col-md-6">
                                <label>Location<span class="required">*</span></label>
                                <input  class="form-control col-md-8"
                                formControlName="Location" readonly [disabled]="true">
                            </div>
                        </div>
    
                    </td>
                </tr>
              <tr>
                <td>
                    <div class="row">
                    
                        <div class="mb-3 col-md-10">
                            <label>Email Id</label>
                            <input  class="form-control col-md-10"
                            formControlName="EmailId" readonly [disabled]="true">
                        </div>
                    </div>
                </td>
              </tr>
             
            </table>
          </div>
        </div>
      </div>
            <!-- <SEARCH FILERS>-->
              <div class="cardSearch">
                <div class="card-header form-control" data-bs-toggle="collapse" href="#collapseFilers" role="button"
                  aria-expanded="false" aria-controls="collapseFilers">
                  <b> Search Filters </b>
                  <span style="margin-left: 1000px;"></span>
                </div>
                <div class="collapse" id="collapseFilers">
                  <div class="card-body">
                    <div class="row">
                      <div class="mb-3 col-md-4">
                        <label>Employee Name:</label>
                        <input type="text" placeholder="Enter Employee Name" class="form-control" formControlName="EmpName" />
                      </div>

                      <div class="mb-3 col-md-4">
                        <label>Employee GPN:</label>
                        <input class="form-control" placeholder="Enter Employee GPN" formControlName="EmpGPN">
                      </div>
                    </div>
                    <div class="BottomBtns" style="float:right">
                      &nbsp;
                      <button mat-stroked-button class="btn-primary1" type="submit" (click)="GetResult()">Get
                        Result</button>
                      &nbsp;
                      <button mat-stroked-button class="btn-primary1" type="button" (click)="Reset()">Reset</button>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="tabel-loading-shade" *ngIf="IsLoadingResults">
                <mat-spinner *ngIf="IsLoadingResults"></mat-spinner>
              </div> -->
              <div class="mat-elevation-z8">
                <mat-table #table [dataSource]="data" matSort>
                  <ng-container matColumnDef="EmpName" mat-sort-header>
                    <mat-header-cell *matHeaderCellDef>Employee Name</mat-header-cell>
                    <mat-cell *matCellDef="let element" data-label="Name"> {{element.EmpName}} </mat-cell>
                  </ng-container>
                  <ng-container matColumnDef="EmpEmail" mat-sort-header>
                    <mat-header-cell *matHeaderCellDef>Employee Email</mat-header-cell>
                    <mat-cell *matCellDef="let element" data-label="EmpEmail:"> {{element.EmpEmail}} </mat-cell>
                  </ng-container>
                  <ng-container matColumnDef="SSL" mat-sort-header>
                    <mat-header-cell *matHeaderCellDef>SSL</mat-header-cell>
                    <mat-cell *matCellDef="let element" data-label="SSL:"> {{element.SSL}}
                    </mat-cell>
                  </ng-container>
                  <ng-container matColumnDef="Location" mat-sort-header>
                    <mat-header-cell *matHeaderCellDef>Location</mat-header-cell>
                    <mat-cell *matCellDef="let element" data-label="Location:"> {{element.Location}}
                    </mat-cell>
                  </ng-container>
                  <ng-container matColumnDef="Role" mat-sort-header>
                    <mat-header-cell *matHeaderCellDef>Role</mat-header-cell>
                    <mat-cell *matCellDef="let element" data-label="UserRole:"> {{element.Role}}
                    </mat-cell>
                  </ng-container>
                  <ng-container matColumnDef="EmpGPN" mat-sort-header>
                    <mat-header-cell *matHeaderCellDef>Action</mat-header-cell>
                    <mat-cell *matCellDef="let element" data-label="Action:">
                       <i href="" (click)="onRemove(element.EmpGPN)"
                        class="pi pi-trash" style="position: absolute;"></i>
                    </mat-cell>
                  </ng-container>
                  <mat-header-row *matHeaderRowDef="displayedColumns;sticky: true"></mat-header-row>
                  <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
                </mat-table>
              </div>
              <mat-paginator #paginator [length]="_global.length" [pageIndex]="_global.pageIndex" [pageSize]="_global.RecordSize"
      [pageSizeOptions]="[5, 10, 25, 100]" (page)="onPaginateChange($event)">
    </mat-paginator>
    </form>
  </p-panel>
</div>